module.exports = __webpack_public_path__ + "static/media/file-word.106d2cb9.svg";